module.exports = __webpack_public_path__ + "img/km.4acdfae7.jpg";